export const ROW_INTERACTIVE_SELECTOR =
  'a, button, input, textarea, select, label, [role="button"], [data-row-click-ignore]';

export function isRowInteractiveTarget(target: EventTarget | null) {
  return target instanceof Element && Boolean(target.closest(ROW_INTERACTIVE_SELECTOR));
}
